import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

export default function JobSearch() {
  const history = useHistory();
  const [values, setValues] = useState({ keyword: "", location: "" });
  
  const words = ["Title", "Keyword", "Level"];
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % words.length);
        setFade(true);
      }, 300);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Build query params
    const params = new URLSearchParams();
    if (values.keyword) params.append("keyword", values.keyword);
    if (values.location) params.append("location", values.location);
    
    // Navigate to job search page with params
    history.push(`/job_search?${params.toString()}`);
  };

  return (
    <form className="sf-job-search" onSubmit={handleSubmit}>
      <div className="sf-search-field" style={{ position: "relative" }}>
        <i className="ri-search-line" />
        <input
          type="text"
          value={values.keyword}
          onChange={(e) => setValues({ ...values, keyword: e.target.value })}
        />
        {!values.keyword && (
          <span className ="sf-job-search-placeholder-new"
            // style={{
            //   position: "absolute",
            //   left: "32px",
            //   pointerEvents: "none",
            //   color: "var(--sf-text-light)",
            //   display: "flex",
            //   alignItems: "center",
            //   gap: "4px",
            //   fontSize: "16px",
            // }}
          >
            Search by{" "}
            <span className={`sf-job-search-words-new ${fade ? "is-faded" : ""}`}> 
              {words[index]}
            </span>
          </span>
        )}
      </div>
      <div className="sf-search-field">
        <i className="ri-map-pin-line" />
        <input
          type="text"
          placeholder="Province or City"
          value={values.location}
          onChange={(e) => setValues({ ...values, location: e.target.value })}
        />
      </div>
      <button type="submit" className="sf-search-btn">
        Find Jobs
      </button>
    </form>
  );
}

